<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="card-title">Πίνακας Συσκευών</h4>
            <p class="card-title-desc">Όλες οι συσκευές</p> -->
            <b-tabs nav-class="nav-tabs-custom" content-class="p-3 text-muted">
              <!-- <b-tabs content-class="p-3 text-muted"> -->
              <b-tab active>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Συσκευές</span>
                </template>
                <FirstTab
                  :devices="devices"
                  @fetchDevices="fetchDevices"
                ></FirstTab>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Λεπτομέρειες</span>
                </template>
                Χρήστες και Παρουσίες Συσκευών
                <SecondTab :devices="devices"></SecondTab>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block"
                    >Συγχρονισμός συσκευών</span
                  >
                </template>
                <ThirdTab :devices="devices"></ThirdTab>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import session from "../../../api/session";
import FirstTab from "./devicesTabs/FirstTab/FirstTab.vue";
import SecondTab from "./devicesTabs/SecondTab/SecondTab.vue";
import ThirdTab from "./devicesTabs/ThirdTab/ThirdTab.vue";

export default {
  page: {
    title: "Συσκευές",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    // FormModal,
    // Multiselect,
    FirstTab,
    SecondTab,
    ThirdTab,
  },
  data() {
    return {
      title: "Συσκευες",
      items: [
        {
          text: "Συσκευές",
          active: true,
        },
      ],
      devices: [],
    };
  },
  mounted() {
    this.fetchDevices();
  },

  methods: {
    async fetchDevices() {
      await session("api/devices/")
        .then((resp) => {
          this.devices = resp.data;
          this.$forceUpdate();
        })
        .catch((e) => {
          console.log(e.response.data);
        });
    },
  },
};
</script>
